import script from "./CertificateGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateGenerator.vue?vue&type=script&setup=true&lang=js"

import "./CertificateGenerator.vue?vue&type=style&index=0&id=d0bb077c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0bb077c"]])

export default __exports__